/**
 * App component with routing
 * Sets up authentication context and routes with dashboard layout
 */
import { Routes, Route } from "react-router-dom";
import { AuthProvider } from "./components/AuthProvider";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { Layout } from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Novels from "./pages/Novels";
import CreateNovel from "./pages/CreateNovel";
import EditNovel from "./pages/EditNovel";
import Chapters from "./pages/Chapters";
import CreateChapter from "./pages/CreateChapter";
import EditChapter from "./pages/EditChapter";
import Settings from "./pages/Settings";
import Tiers from "./pages/Settings/Tiers";

function App() {
  return (
    <AuthProvider>
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<Login />} />

        {/* Protected routes with layout */}
        <Route
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route path="/" element={<Dashboard />} />
          <Route path="/novels" element={<Novels />} />
          <Route path="/novels/new" element={<CreateNovel />} />
          <Route path="/novels/:id/edit" element={<EditNovel />} />
          <Route path="/novels/:id/chapters" element={<Chapters />} />
          <Route path="/novels/:id/chapters/new" element={<CreateChapter />} />
          <Route
            path="/novels/:id/chapters/:chapterId/edit"
            element={<EditChapter />}
          />
          <Route path="/settings" element={<Settings />} />
          <Route path="/settings/tiers" element={<Tiers />} />
        </Route>
      </Routes>
    </AuthProvider>
  );
}

export default App;
